"use client";

import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function CaseStudies() {
  const artifacts = [{
    id: 1,
    title: "Harry Chapman",
    spec: "Social Media Amplification & Audience Insight",
    description: "Harry volunteered to join The Flavel Marketing team for 2 days a week with the objective of getting relevant work experience for a job in Digital Marketing.",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706701/img/marketing_digital_project.webp",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706701/img/marketing_digital_project.webp-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706701/img/marketing_digital_project.webp-wvc-sizes",
      alt: "Harry Chapman - Marketing and digital transformation project"
    },
    gridClasses: "col-span-12 md:col-span-6 lg:col-span-4",
    aspectClasses: "aspect-[3/4]"
  }, {
    id: 2,
    title: "Anna Scheer",
    spec: "Sustainability Skills Development",
    description: "Anna volunteered to use what she had been taught in her Environmental, Social, Governance (ESG) MSc at Kings College, to create a Sustainability framework. Anna wanted this experience to target a career in ESG Management.",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706701/img/esg_sustainability_project.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706701/img/esg_sustainability_project.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706701/img/esg_sustainability_project.png-wvc-sizes",
      alt: "Anna Scheer - ESG and sustainability project implementation"
    },
    gridClasses: "col-span-12 md:col-span-6 lg:col-span-4",
    aspectClasses: "aspect-[3/4]"
  }];
  return <section data-section-id="2781" id="realoutcomescasestudy" className="bg-background text-foreground py-20 md:py-28 lg:py-36 px-6 md:px-10 lg:px-16">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 mb-16 md:mb-24 items-start">
          
          <div className="md:col-span-7">
            
            <h2 className="font-default font-light text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-foreground">The idea in action</h2>
          </div>
          <div className="md:col-span-4 md:flex md:justify-end md:items-end md:h-full">
            <Link to="/CaseStudiesPage" className="group inline-flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-foreground border-b border-border pb-1 hover:border-primary transition-colors duration-500">
              <span>View all projects</span>
              <ArrowUpRight className="size-3.5 transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1" strokeWidth={1.5} />
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-6 md:gap-8">
          {artifacts.map((item, i) => <div key={item.id} data-index={i} className={`group flex flex-col overflow-hidden rounded-lg bg-card shadow-md ${item.gridClasses}`}>
              <div className={`relative w-full overflow-hidden ${item.aspectClasses}`}>
                <img src={item.image.src} data-wvc-srcset={item.image.srcset} data-wvc-sizes={item.image.sizes} alt={item.image.alt} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]" />

                <div className="absolute top-4 left-4 z-10">
                  <span className="font-mono text-[10px] uppercase tracking-widest text-white bg-primary/80 backdrop-blur-sm px-2 py-1 rounded-md">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
              </div>

              <div className="flex flex-col p-6 md:p-8 flex-grow">
                <h3 className="font-default text-xl md:text-2xl text-foreground leading-tight mb-2">
                  {item.title}
                </h3>
                <p className="font-mono text-[10px] uppercase tracking-widest text-primary mb-4">
                  {item.spec}
                </p>
                <p className="font-default text-sm text-muted-foreground leading-relaxed mb-6 flex-grow">
                  {item.description}
                </p>
                <div className="mt-auto">
                  <Link to="/CaseStudiesPage" className="group/link inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-widest text-foreground border-b border-border pb-1 hover:border-primary transition-colors duration-500">
                    <span>Read Case Study</span>
                    <ArrowUpRight className="size-3 transition-transform duration-500 group-hover/link:translate-x-0.5 group-hover/link:-translate-y-0.5" strokeWidth={1.5} />
                  </Link>
                </div>
              </div>
            </div>)}
        </div>

        
      </div>
    </section>;
}